import React, { useId, useRef } from "react";
import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";

export const DASHLY_FIELD_LABEL_INFO_TOOLTIP_TARGET = "dashly-field-label-info";

type DashlyFieldLabelInfoProps = {
    content?: string;
    className?: string;
};

export const DashlyFieldLabelInfo: React.FC<DashlyFieldLabelInfoProps> = ({ content, className }) => {
    const trimmed = `${content ?? ""}`.trim();
    const buttonRef = useRef<HTMLButtonElement>(null);
    const tooltipId = useId().replace(/[^a-zA-Z0-9_-]/g, "");

    if (!trimmed) {
        return null;
    }

    return (
        <>
            <button
                ref={buttonRef}
                type="button"
                id={`dashly-field-label-info-${tooltipId}`}
                className={classNames(DASHLY_FIELD_LABEL_INFO_TOOLTIP_TARGET, className)}
                aria-label={trimmed}
                onClick={(event) => event.stopPropagation()}
            >
                <i className="pi pi-info-circle" aria-hidden />
            </button>
            <Tooltip
                target={buttonRef}
                content={trimmed}
                position="top"
                showDelay={150}
                hideDelay={50}
                autoZIndex
                className="dashly-field-label-info-tooltip"
            />
        </>
    );
};

export type DashlyFieldLabelProps = {
    label: React.ReactNode;
    labelInfo?: string;
    required?: boolean;
    className?: string;
};

export const DashlyFieldLabel: React.FC<DashlyFieldLabelProps> = ({
    label,
    labelInfo,
    required,
    className,
}) => (
    <span className={classNames("dashly-field-shell__label-text", className)}>
        <span className="dashly-field-shell__label-copy">{label}</span>
        {required ? (
            <span className="dashly-field-shell__required" aria-hidden="true">
                *
            </span>
        ) : null}
        <DashlyFieldLabelInfo content={labelInfo} />
    </span>
);

/** @deprecated Label info icons mount their own PrimeReact tooltip. Kept for backwards compatibility. */
export const DashlyFieldLabelInfoTooltip: React.FC<{
    className?: string;
    position?: "top" | "bottom" | "left" | "right";
    showDelay?: number;
    hideDelay?: number;
}> = () => null;
